import type { WeekIndicatorsValues } from 'core/api/home/weekly/useApiGetWeekIndicators'
import { daysArray } from './daily-board-utils'
import DailyDataUnavailable from './daily-data-unavailable'
import { useFormatNumber } from 'core/hooks/useFormatNumber'

interface DailyBoardRealizedProps {
  weeklyData: Record<number, WeekIndicatorsValues>
  isCurrentWeek: boolean
}

const DailyBoardRealized = ({ weeklyData, isCurrentWeek }: DailyBoardRealizedProps) => {
  const formatNumber = useFormatNumber()
  const today = new Date().getDay() + 1

  return (
    <>
      {daysArray.map(day => {
        const indicatorsValues = weeklyData?.[day]
        return (
          <div
            key={day}
            data-testid={`realized-cell-${day}`}
            className={
              'vp-body-s' + (isCurrentWeek && today === day ? ' mg-daily-board-item-today' : ' mg-daily-board-item')
            }
          >
            {weeklyData == null || indicatorsValues?.realized_gmv?.in_error ? (
              <DailyDataUnavailable />
            ) : (
              formatNumber(indicatorsValues?.realized_gmv?.value, '-', { maximumFractionDigits: 0 })
            )}{' '}
            /
            {weeklyData == null || indicatorsValues?.forecast_gmv?.in_error ? (
              <DailyDataUnavailable />
            ) : (
              formatNumber(indicatorsValues?.forecast_gmv?.value, '-', { maximumFractionDigits: 0 })
            )}
          </div>
        )
      })}
    </>
  )
}

export default DailyBoardRealized
